import { useState } from 'react';
import '../../styles/SignInUp.css';
import axios from 'axios';
import { useNavigate, Link} from 'react-router-dom';
import { useToast } from '../ToastContext';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import ReactGA from 'react-ga4';

function SignUp() {
  const API_URL = process.env.REACT_APP_API_URL;

  const {showToast} = useToast();

  const navigate = useNavigate();

  const {executeRecaptcha} = useGoogleReCaptcha();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [policyAndTerms, setPolicyAndTerms] = useState();

  const [passwordLength, setPasswordLength] = useState(false);
  const [passwordNumber, setPasswordNumber] = useState(false);
  const [passwordChar, setPasswordChar] = useState(false);
  const [passwordSmallLetter, setPasswordSmallLetter] = useState(false);
  const [passwordBigLetter, setPasswordBigLetter] = useState(false);

  const [passwordAccepted, setPasswordAccepted] = useState();
  const [samePasswords, setSamePasswords] = useState();

  const passwordConditions = (pass) => {
    const isLengthValid = pass.length > 7;
    setPasswordLength(isLengthValid);
    

    const numbers = /[0-9]/
    const isNoValid = numbers.test(pass);
    setPasswordNumber(isNoValid);

    const chars = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`]/;
    const isCharValid = chars.test(pass);
    setPasswordChar(isCharValid);

    const smallLetters = /[a-z]/
    const bigLetters = /[A-Z]/

    const isSLetterValid = smallLetters.test(pass);
    setPasswordSmallLetter(isSLetterValid);

    const isBLetterValid = bigLetters.test(pass);
    setPasswordBigLetter(isBLetterValid);

    setPassword(pass);
  }

  const checkPasswords = (pass) => {
    if (passwordLength && passwordNumber && passwordChar && passwordSmallLetter && passwordBigLetter) {
      setPasswordAccepted(true);
    } else {
      setPasswordAccepted(false);
    }

    if (password === pass) {
      setSamePasswords(true);
    } else {
      setSamePasswords(false);
    }
  }


  const handleRegister = async (e) => {
    e.preventDefault();

    if(!executeRecaptcha){
      return;
    }

    const captchaToken = await executeRecaptcha("register")

    if (samePasswords && passwordAccepted && policyAndTerms) {
      try {
        const response = await axios.post(`${API_URL}/users/register`, { email, password, captchaToken })

        if (response.data) {
          //GA
          ReactGA.event({
            category: 'User',
            action: 'sign_up',
            label: 'Rejestracja konta'
          });

          navigate('/weryfikacja-rejestracji', {state: {email: email}});
        } else {
          showToast("Wystąpił błąd, spróbuj ponownie.", "error")
        }

      } catch (error) {
        if (error.response) {
          if (error.response.status === 409) {
            showToast("Użytkownik z takim e-mail już istnieje", "error")
          } else {
            showToast("Wystąpił błąd, spróbuj ponownie.", "error")
          }
        } else {
          showToast("Błąd połączenia z serwerem", "error")
        }
      }
    };
  }


  return (
    <div className="register-wrapper">
      <div className="register-card">
        <h2 className="register-title">
          Dołącz do TRADI<span className="logo-highlight">WORLD</span>
        </h2>
        <p className="register-subtitle">Zacznij mapować swoje podróże i wspomnienia już dziś.</p>

        <form onSubmit={handleRegister} method='POST' className="register-form">
          <div className="input-group">
            <label htmlFor="email">Adres e-mail</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="twoj@email.com"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="password">Hasło</label>
            <input
              type="password"
              id="password"
              name="password"
              placeholder="••••••••"
              onChange={(e) => passwordConditions(e.target.value)}
              required
            />

            <p style={{ "color": `${passwordLength ? "green" : "red"}`, "fontSize": "small" }}>Minimum 8 znaków</p>
            {passwordNumber ? <p style={{ "color": "green", "fontSize": "small" }}>Zawiera liczbę</p> : <p style={{ "color": "red", "fontSize": "small" }}>Zawiera liczbę</p>}
            {passwordChar ? <p style={{ "color": "green", "fontSize": "small" }}>Zawiera znak specjalny</p> : <p style={{ "color": "red", "fontSize": "small" }}>Zawiera znak specjalny</p>}
            {passwordSmallLetter && passwordBigLetter ? <p style={{ "color": "green", "fontSize": "small" }}>Zawiera dużą i małą literę</p> : <p style={{ "color": "red", "fontSize": "small" }}>Zawiera dużą i małą literę</p>}
          </div>

          <div className="input-group">
            <label htmlFor="password">Powtórz hasło</label>
            <input
              type="password"
              id="password"
              name="password"
              placeholder="••••••••"
              onChange={(e) => checkPasswords(e.target.value)}
              required
            />
            {samePasswords ? <></> : <p style={{ "color": "red", "fontSize": "small" }}>Hasła nie są takie same</p>}
          </div>

          <div className="checkbox-group">
            <input
              type="checkbox"
              id="acceptTerms"
              name="acceptTerms"
              onChange={(e) => setPolicyAndTerms(e.target.checked)}
              required
            />
            <label htmlFor="acceptTerms">
              Akceptuję <a href="/regulamin-serwisu-tradiworld.pdf" target='_blank' rel="noopener noreferrer">Regulamin</a> oraz <a href="/polityka-prywatnosci-tradiworld.pdf" target='_blank' rel="noopener noreferrer">Politykę prywatności</a>
            </label>
          </div>

          <button type="submit" className="register-button">
            Utwórz darmowe konto
          </button>
        </form>

        <p className="register-footer">
          Masz już konto? <Link to="/logowanie">Zaloguj się</Link>
        </p>
      </div>
    </div>
  );
}

export default SignUp;